<template>
  <svg
    width="208"
    height="174"
    viewBox="0 0 104 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.9936 0H17.2007C7.70103 0 0 7.70103 0 17.2007V68.7928C0 78.2925 7.70103 85.9936 17.2007 85.9936H85.9936C95.4933 85.9936 103.194 78.2925 103.194 68.7928V17.2007C103.194 7.70103 95.4933 0 85.9936 0Z"
      fill="#0B132B"
    />
    <g style="mix-blend-mode:hard-light">
      <path
        d="M103.194 17.1906L93.2424 19.671C66.4744 26.1706 39.3217 32.6804 13.0094 38.9877C8.66617 40.0304 4.32296 41.0732 0 42.1059V17.1906C0 7.68414 7.70439 0 17.2109 0H86.0037C95.5101 0 103.194 7.69427 103.194 17.1906Z"
        fill="url(#paint0_linear_9_1089)"
      />
    </g>
    <path
      d="M33.5711 73.3447C39.2687 73.3447 43.8875 68.7259 43.8875 63.0283C43.8875 57.3307 39.2687 52.7119 33.5711 52.7119C27.8735 52.7119 23.2547 57.3307 23.2547 63.0283C23.2547 68.7259 27.8735 73.3447 33.5711 73.3447Z"
      fill="#4CE0B3"
    />
    <path
      d="M69.633 73.4466C75.3306 73.4466 79.9494 68.8278 79.9494 63.1302C79.9494 57.4327 75.3306 52.8138 69.633 52.8138C63.9354 52.8138 59.3166 57.4327 59.3166 63.1302C59.3166 68.8278 63.9354 73.4466 69.633 73.4466Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.5712 68.1926C36.4228 68.1926 38.7345 65.8809 38.7345 63.0293C38.7345 60.1778 36.4228 57.8661 33.5712 57.8661C30.7196 57.8661 28.408 60.1778 28.408 63.0293C28.408 65.8809 30.7196 68.1926 33.5712 68.1926Z"
      fill="#A6F4D8"
    />
    <path
      d="M69.6331 68.2936C72.4846 68.2936 74.7963 65.9819 74.7963 63.1303C74.7963 60.2787 72.4846 57.967 69.6331 57.967C66.7815 57.967 64.4698 60.2787 64.4698 63.1303C64.4698 65.9819 66.7815 68.2936 69.6331 68.2936Z"
      fill="#A6F4D8"
    />
    <path
      d="M69.4246 40.4401C68.8071 40.4401 68.1794 40.6729 67.7137 41.1488C66.762 42.1004 66.762 43.6292 67.7137 44.5808C71.4697 48.3368 76.4507 50.4629 81.7557 50.5742C83.0718 50.635 84.2057 49.5416 84.2361 48.1951C84.2665 46.8587 83.2035 45.7451 81.857 45.7147C77.8073 45.6236 74.0007 44.0037 71.1457 41.1386C70.6699 40.6628 70.0523 40.43 69.4246 40.43V40.4401Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.8121 40.4398C34.4297 40.4398 35.0574 40.6727 35.5231 41.1485C36.4748 42.1002 36.4748 43.6289 35.5231 44.5806C31.7671 48.3366 26.7861 50.4626 21.4811 50.574C20.1649 50.6347 19.0311 49.5413 19.0007 48.1949C18.9703 46.8585 20.0333 45.7448 21.3798 45.7145C25.4294 45.6234 29.2361 44.0035 32.0911 41.1384C32.5669 40.6626 33.1845 40.4297 33.8121 40.4297V40.4398Z"
      fill="#4CE0B3"
    />
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M16.8158 63.7858C16.9373 50.8574 24.5404 40.4094 33.7938 40.4398C43.0471 40.4803 50.4478 50.989 50.3263 63.9275C50.2048 76.8559 42.6017 87.3039 33.3483 87.2736C24.095 87.2331 16.6943 76.7243 16.8158 63.7858Z"
        fill="url(#paint1_radial_9_1089)"
      />
    </g>
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M53.2625 63.7855C53.384 50.8572 60.9872 40.4091 70.2405 40.4395C79.4939 40.48 86.8946 50.9888 86.7731 63.9273C86.6516 76.8557 79.0484 87.3037 69.7951 87.2733C60.5417 87.2328 53.141 76.7241 53.2625 63.7855Z"
        fill="url(#paint2_radial_9_1089)"
      />
    </g>
    <path
      d="M85.9936 2.42977C94.1434 2.42977 100.765 9.06101 100.765 17.2007V68.8029C100.765 76.9528 94.1333 83.5739 85.9936 83.5739H17.2007C9.05088 83.5739 2.42976 76.9427 2.42976 68.8029V17.2007C2.42976 9.05089 9.06101 2.42977 17.2007 2.42977H85.9936ZM85.9936 0H17.2007C7.70439 0 0 7.70439 0 17.2007V68.8029C0 78.2993 7.70439 86.0037 17.2007 86.0037H85.9936C95.4899 86.0037 103.194 78.2993 103.194 68.8029V17.2007C103.194 7.70439 95.5 0 85.9936 0Z"
      fill="#0B132B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9_1089"
        x1="125.012"
        y1="-14.9633"
        x2="18.5675"
        y2="22.8601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2853E1" />
        <stop
          offset="1"
          stop-color="#2853E1"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9_1089"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.6115 63.5836) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9_1089"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.0583 63.5834) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
